import { render } from "./PageCopyright.vue?vue&type=template&id=8bebd884"
const script = {}

import "./PageCopyright.vue?vue&type=style&index=0&id=8bebd884&lang=css"

import exportComponent from "/var/www/digiasia.asia.bak/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__